import { get } from '../core/http';
import type { FrontNavigationConfigItem } from '@dts/shared/src/types/frontNavigation';

export const frontNavigationApi = {
  getFrontNavigationList() {
    return get<FrontNavigationConfigItem[]>('/front_navigation/front/list');
  },
};
